// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"ee06b7ac","239":"50f5cbf3","389":"9756a75d","453":"8eb871ff","455":"270a58d2","492":"1ac69adb","529":"bfcb2ea1","608":"f9c0cc90","732":"0dcdb9fa","977":"d88b8917"}[chunkId] + ".chunk.js";
};